import React from 'react';
import { Helmet } from 'react-helmet-async';
import { generatePageMeta, generateBusinessStructuredData } from '../lib/seo';

const SEOHead = ({ 
  title, 
  description, 
  keywords = [], 
  image, 
  url, 
  type = "website",
  noindex = false 
}) => {
  const metaData = generatePageMeta({
    title,
    description,
    keywords,
    image,
    url,
    type,
    noindex
  });

  const structuredData = generateBusinessStructuredData();

  return (
    <Helmet>
      <title>{metaData.title}</title>
      <meta name="description" content={metaData.description} />
      <meta name="keywords" content={metaData.keywords} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={metaData.url} />
      
      {/* Open Graph */}
      <meta property="og:type" content={metaData.openGraph.type} />
      <meta property="og:url" content={metaData.openGraph.url} />
      <meta property="og:title" content={metaData.openGraph.title} />
      <meta property="og:description" content={metaData.openGraph.description} />
      <meta property="og:image" content={metaData.openGraph.image} />
      <meta property="og:site_name" content={metaData.openGraph.siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content={metaData.twitter.card} />
      <meta name="twitter:url" content={metaData.twitter.url} />
      <meta name="twitter:title" content={metaData.twitter.title} />
      <meta name="twitter:description" content={metaData.twitter.description} />
      <meta name="twitter:image" content={metaData.twitter.image} />
      <meta name="twitter:creator" content={metaData.twitter.creator} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
